export default __webpack_public_path__ + "static/media/EM0090.34I-19685_-14855_0.39b545e5.jpg";